<template>
  <!-- O TEMPLATE ESTÁ PERFEITO -->
  <div class="hex-background-container">
    <div class="grid"></div>
    <div class="light" :style="lightStyle"></div>
  </div>
</template>

<script setup>
// O SCRIPT ESTÁ PERFEITO
import { computed } from 'vue'

/* eslint-disable no-undef */
const props = defineProps({
  mouseX: Number,
  mouseY: Number
})
/* eslint-enable no-undef */

const lightStyle = computed(() => {
  if (props.mouseX === 0 && props.mouseY === 0) {
    return { left: '50%', top: '50%' }
  }
  return {
    left: `${props.mouseX}px`,
    top: `${props.mouseY}px`
  }
})
</script>

<style scoped>
/* A MUDANÇA ESTÁ AQUI EMBAIXO */

.hex-background-container {
  /* É o fundo preto fixo */
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #000; /* Fundo preto */
  z-index: 0; /* Fica atrás do seu site (#app) */
  overflow: hidden;
}

.grid {
  /* É o grid (a imagem) */
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url(/public/grid.svg) repeat;
  background-size: 500px;
  
  /* MUDANÇA: O grid agora fica na FRENTE do brilho */
  z-index: 2;
  
  /* As linhas do grid devem ser sólidas */
  opacity: 1; 
}

.light {
  /* É o feixe de luz */
  position: absolute;
  transform: translate(-50%, -50%);
  
  /* Tamanho grande */
  width: 300px;
  height: 300px;
  
  /* Blur grande */
  filter: blur(80px);
  
  background: linear-gradient(90deg, #335bf4 0%, #2ae9c9 100%);

  
  /* MUDANÇA: O brilho agora fica ATRÁS do grid */
  z-index: 1;
  
  transition: left 0.05s linear, top 0.05s linear;
  
  /* A animação continua a funcionar */
  animation: rainbow-cycle 10s linear infinite;
}

@keyframes rainbow-cycle {
  0% {
    filter: blur(80px) hue-rotate(0deg);
  }
  100% {
    filter: blur(80px) hue-rotate(360deg);
  }
}
</style>